'use strict';

import getNgModule from "getNgModule";
var ngModule = getNgModule(__filename);
ngModule.config(function () {
  $.extend($.jGrowl.defaults, {
    themeState: "no-state",
    position: "tl-notification-desk",
    closer: false,
    // "close all" button
    life: 6000,
    animateOpen: {
      opacity: "show",
      right: "+=200px"
    },
    animateClose: {
      opacity: "hide",
      right: "-=200px"
    }
  });
});
ngModule.factory("$notifications", function () {
  var addMessage = function addMessage(message, type, options) {
    $.jGrowl(message, _.extend(options, {
      theme: type
    }));
  };
  return {
    info: function info(message, options) {
      addMessage(message, "info", options || {});
    },
    error: function error(message, options) {
      addMessage(message, "error", options || {});
    },
    warn: function warn(message, options) {
      addMessage(message, "warn", options || {});
    }
  };
});


//////////////////
// WEBPACK FOOTER
// ./src/modules/common/ng/services/$notifications.js
// module id = 2863
// module chunks = 13